<template>
  <div class="[&_textarea]:!h-min [&_textarea]:!border-none [&_textarea]:!py-4">
    <slot />
  </div>
</template>
